import { TIcon } from "../components/CRMIcon/CRMIcon";

export type TGuideProductId = "legal" | "homes" | "probate";

export type TGuideCategory = {
    id: string;
    title: string;
    description: string;
};

export type TGuideProduct = {
    id: TGuideProductId;
    title: string;
    icon: TIcon;
    categories: Array<TGuideCategory>;
};

export const guideProducts: Array<TGuideProduct> = [
    {
        id: "legal",
        title: "Sail Legal",
        icon: "legal-gavel",
        categories: [
            {
                id: "getting-started",
                title: "Getting started",
                description: "Logging in, the dashboard, the case list, the day view, search.",
            },
            {
                id: "case-view",
                title: "Case view",
                description: "Every panel of a case page and what it does.",
            },
            {
                id: "roadblocks",
                title: "Roadblocks",
                description: "How they work, how to clear them, how they refresh.",
            },
            {
                id: "title-check",
                title: "Title check",
                description: "How the system reads a title and what it flags.",
            },
            {
                id: "legal-practice",
                title: "Legal practice",
                description: "Conveyancing playbooks — transfers, leasehold, probate sales.",
            },
            {
                id: "communications",
                title: "Communications",
                description: "Email coach, CLEAR review, instructed emails, reminders.",
            },
            {
                id: "service-and-complaints",
                title: "Service & complaints",
                description: "Internal complaints handling, service levels, escalation.",
            },
            {
                id: "compliance-and-policies",
                title: "Compliance & policies",
                description: "Regulatory policies: AML, complaints, conflicts, and CLC compliance.",
            },
            {
                id: "reference",
                title: "Reference",
                description: "Glossary, interfaces, and lookup material.",
            },
            {
                id: "training-sessions",
                title: "Training sessions",
                description: "The Sail Legal foundational conveyancing series.",
            },
            {
                id: "money-and-ledgers",
                title: "Money & ledgers",
                description: "Fees, ledger entries, referral fees, refunds.",
            },
        ],
    },
    {
        id: "homes",
        title: "Sail Homes",
        icon: "house-with-person",
        categories: [],
    },
    {
        id: "probate",
        title: "Sail Probate",
        icon: "house-and-building",
        categories: [],
    },
];

export const findProduct = (productId: string): TGuideProduct | undefined =>
    guideProducts.find((p) => p.id === productId);

export const findCategory = (
    product: TGuideProduct,
    categoryId: string
): TGuideCategory | undefined =>
    product.categories.find((c) => c.id === categoryId);
